import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  ldErrTitle: 'Oops! Something went wrong',
  ldErrDesc: 'There was a problem loading this feature. Please try again.',
  ldErrGoToDashboard: 'Go to Dashboard',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const LOAD_MFE_ERROR_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    ldErrTitle: '¡Ups! Algo salió mal',
    ldErrDesc:
      'Hubo un problema al cargar esta función. Por favor, inténtalo de nuevo.',
    ldErrGoToDashboard: 'Ir al dashboard',
  },
};

export default LOAD_MFE_ERROR_LABELS;
